import { type MCPServerInfo } from '../../types';

const CyeraDataportServer: MCPServerInfo = {
  serverId: 'CYERA_DATAPORT',
  name: 'Cyera DataPort (Snowflake)',
  slug: 'cyera-dataport',
  description:
    "Cyera DataPort MCP Server for querying Cyera's DataPort Snowflake dataset (loads context from S3 + executes read-only queries)",
  source: {
    sourceType: 'REPOSITORY',
    type: 'OFFICIAL',
    repositoryUrl: 'https://github.com/cyera/cyera-dataport-mcp',
    commitSha: 'latest',
    packageType: 'docker',
    packageName: 'mcp/cyera-dataport'
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [
      'snowflakeAccount',
      'snowflakeUser',
      'snowflakeRsaPrivateKey',
      'awsAccessKeyId',
      'awsSecretAccessKey'
    ],
    properties: {
      snowflakeAccount: {
        type: 'string',
        description: 'Snowflake account identifier',
        sensitive: false
      },
      snowflakeUser: {
        type: 'string',
        description: 'Snowflake user',
        sensitive: false
      },
      snowflakeRsaPrivateKey: {
        type: 'string',
        description:
          'Snowflake RSA private key contents (PEM). Stored as a Natoma secret and written to a temp file at runtime.',
        sensitive: true
      },
      snowflakeRsaKeyPassphrase: {
        type: 'string',
        description: 'Optional passphrase for the RSA private key',
        default: '',
        sensitive: true
      },
      snowflakeRole: {
        type: 'string',
        description: 'Optional Snowflake role',
        default: 'DATAPORT_MCP_READONLY',
        sensitive: false
      },
      snowflakeDatabase: {
        type: 'string',
        description: 'Optional Snowflake database',
        default: 'CYERA_DATAPORT',
        sensitive: false
      },
      snowflakeWarehouse: {
        type: 'string',
        description: 'Optional Snowflake warehouse',
        default: 'WH_LARGE',
        sensitive: false
      },
      snowflakeSchema: {
        type: 'string',
        description: 'Optional Snowflake schema',
        default: 'product',
        sensitive: false
      },
      awsAccessKeyId: {
        type: 'string',
        description: 'AWS access key id (for S3 context bucket)',
        sensitive: true
      },
      awsSecretAccessKey: {
        type: 'string',
        description: 'AWS secret access key (for S3 context bucket)',
        sensitive: true
      },
      s3BucketName: {
        type: 'string',
        description: 'Optional S3 bucket name for context files',
        default: 'edp-mcp',
        sensitive: false
      }
    }
  }
};

export default CyeraDataportServer;
